import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const testimoniosModule = {
	state: {
		testimonios : ''
	},
	getters: {  
        getTestimonios : state => state.testimonios
	},
	actions: {
        requestTestimonios({commit,dispatch}, tipo){

			let urls = {
				'' : '/api/Empresa/dameTestimonios/',
				'empresa' : '/api/Empresa/dameTestimonios/',
				'practicas' : '/api/Alumno/dameTestimonios/',
				'empleo' : '/api/Alumno/dameTestimonios/',
			}

            return new Promise((resolve, reject) => {
				axios.get(urls[tipo]+"/1").then( result => {
					if(result.data.status == 0){
						if(result.data.datos.numPaginas > 1){
							let data = {
								max: result.data.datos.numPaginas,
								page: 1,
								url : urls[tipo]
							};
								dispatch('requestMoreTestimonios', data);
						}else{
							commit('setTestimonios', result.data.datos.testimonios); 
						}
					}else{
						commit('setError',result.data.status)
					}
					resolve(true);
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		requestMoreTestimonios({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

				if (data.page <= data.max) {

                    axios.get(data.url + data.page).then(result => {

                        if (result.data.status == 0) {
							commit('addTestimonios', result.data.datos.testimonios);
							data.page++;
                            dispatch('requestMoreTestimonios', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

					});
				}
            });
        },
	},
	mutations: {
        setTestimonios(state, testimonios){
            state.testimonios = testimonios;
		},
		addTestimonios(state, testimonio){


			if(!!!state.testimonios){
				state.testimonios = new Array();
			}

			state.testimonios = state.testimonios.concat(testimonio);

		}
	}
}

export default testimoniosModule;


// WEBPACK FOOTER //
// ./src/store/testimoniosModule.js